import {
  ArrowSwap20Regular,
  Delete20Regular,
  DismissRegular,
  Edit20Regular,
} from "@fluentui/react-icons";
import React from "react";

interface IPayoutPopoverOptionsProps {
  setOpen: Function;
  onClose: () => void;
  handleEdit: () => void;
  handleChange: () => void;
  handleDelete: () => void;
}

const PayoutPopoverOptions: React.FC<IPayoutPopoverOptionsProps> = ({
  setOpen,
  onClose,
  handleEdit,
  handleDelete,
  handleChange,
}) => {
  const iconClass = "inline-block h-6 w-6 rounded-full m-auto mr-2 text-black";

  const options = [
    {
      icon: <Edit20Regular className={iconClass} />,
      text: "Edit",
      action: () => {
        handleEdit();
      },
    },
    {
      icon: <ArrowSwap20Regular className={iconClass} />,
      text: "Change",
      action: () => {
        handleChange();
      },
    },
    {
      icon: <Delete20Regular className={`${iconClass} text-red-500`} />,
      text: "Delete",
      action: () => {
        handleDelete();
      },
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div
        className="flex gap-4 items-end md:hidden justify-end"
        onClick={() => setOpen(true)}
      >
        <DismissRegular
          className=" md:hidden cursor-pointer"
          fontSize={24}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      </div>
      {options?.map((option) => {
        return (
          <div
            key={option?.text}
            className="cursor-pointer "
            onClick={() => option?.action()}
          >
            {option?.icon}
            <span className={option?.text === "Delete" ? "text-red-500" : ""}>
              {option?.text}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PayoutPopoverOptions;
